export default __webpack_public_path__ + "static/media/item5.f73d0a1f.png";